export default {
    name: 'basicConfig',
    state: {
        dateFormat: "DD-MM-YYYY",
        standarFormat: "YYYY-MM-DD",
        dateTimeFormat : "DD-MM-YYYY HH:mm:ss",
        dateTimeStandart : "YYYY-MM-DD HH:mm:ss"
    },
    getters: {
        getDefaultDateFormat: state => {
            return state.dateFormat
        },
        getStandartFormatDate:state =>{
            return state.standarFormat
        },
        getDateTimeFormat :state =>{
            return state.dateTimeFormat
        },
        getDateTimeStandartFormat :state =>{
            return state.dateTimeStandart
        },
    }
}